import styled, { css, keyframes } from "styled-components";
import { colors, header } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import { safeAreaAbsoluteTop } from "../../../styles/safeArea";
import TrayContainer from "../../atoms/TrayContainer";

const sheetAppearing = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const sheetDisappearing = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(140%); }
`;

export const StyledMerchTray = styled(TrayContainer)<{
  isVariantSmall: boolean;
  isOpened: boolean;
  hide: boolean;
  widthXsUp: string;
  topPadding: string;
}>`
  background-color: ${colors.white};
  ${breakpoints.xsUp} {
    width: ${(props) => props.widthXsUp};
  }
  ${breakpoints.xsDown} {
    width: 100%;
  }
  max-height: 100%;
  z-index: 2200;
  overflow-x: hidden;
  ${breakpoints.mdUp} {
    ${(props) =>
      !props.isVariantSmall &&
      css`
        top: ${header.desktopHeight};
      `}
  }
  ${breakpoints.smDown} {
    min-height: 100%;
  }
  ${(props) =>
    !props.isOpened &&
    css`
      display: none;
    `}
  display: flex;
  flex-direction: column;
  animation: ${(props) => (props.hide ? sheetDisappearing : sheetAppearing)};
  animation-duration: 0.4s;
  /* TrayContainer already folds env into padding-top; topPadding adds
   * whatever extra offset the variant wants above its first flow child. */
  padding-top: calc(env(safe-area-inset-top) + ${(props) => props.topPadding});
`;

export const CloseTrayButton = styled.div`
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  position: absolute;
  z-index: 1;
  ${safeAreaAbsoluteTop(30)}
  left: 30px;
  width: 40px;
  height: 40px;
  > img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`;
